module.exports = __webpack_public_path__ + "static/media/57.94d13db7.png";